<script lang="ts" setup>
import { FAQ_ENTRIES_KEY } from '../page-builder'
import FaqCardList from '@/components/FaqCardList.vue'

const faqEntries = inject(FAQ_ENTRIES_KEY)!
</script>

<template>
  <div class="pointer-events-none">
    <FaqCardList :faq-entries />
  </div>
</template>
